export const state = {
  successNotification: {
    message: null,
    show: false
  },
  errorNotification: {
    message: null,
    show: false
  }
};

export const mutations = {
  ADD_SUCCESS_NOTIFICATION(state, notification) {
    state.successNotification = notification;
    setTimeout(() => {
      state.successNotification.show = false;
    }, 3500);
  },
  ADD_ERROR_NOTIFICATION(state, notification) {
    state.errorNotification = notification;
  },
  DELETE(state) {
    state.errorNotification = {
      message: null,
      show: false
    };
  }
};

export const actions = {
  addNotification({ commit }, notification) {
    if (notification.type === 'success') commit('ADD_SUCCESS_NOTIFICATION', notification);
    if (notification.type === 'error') commit('ADD_ERROR_NOTIFICATION', notification);
  },
  removeErrorNotification({ commit }, notificationId) {
    commit('DELETE', notificationId);
  }
};
